module.exports = __webpack_public_path__ + "static/img/register.ee396cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/register/fetal-monitor/register.png
// module id = 0djV
// module chunks = 1